import React, { useMemo } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { CameraType } from '../../../schemas/cameras';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

type Props = {
    required?: boolean;
    zIndex: number;
    includeAll: boolean;
    disabled?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: CameraType | 'all';
    setValue: React.Dispatch<React.SetStateAction<CameraType | 'all'>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function CameraTypeDropdown({ value, setValue, zIndex, form, fieldName, required, includeAll, disabled }: Props) {
    const items = useMemo(() => {
        const types: string[] = ['ptz', 'lpr', 'pinned', 'panoramic'];
        if (includeAll) {
            types.unshift('all');
        }
        return types.map(type => ({ label: translate(type), value: type }));
    }, [includeAll]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('cameraType')}
            items={items}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
            required={required}
            disabled={disabled}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterDropdown
            label={translate('cameraType')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            required={required}
            disabled={disabled}
        />;
    }
}

export default CameraTypeDropdown;
